let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d4ETO")).then(() => parcelRequire('9Rcfo'));